import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { PaginationDot } from './PaginationDot';

const rootStyles = {
  position: 'absolute',
  bottom: '10%',
  right: '50%',
  display: 'flex',
  flexDirection: 'row',
  marginRight: `${-72}px`,
};

class PaginationMobile extends Component {
  constructor(props) {
    super(props);

    this.handleClick = this.handleClick.bind(this);
  }

  handleClick(_event, index) {
    this.props.onChangeIndex(index);
  }

  render() {
    const { index, dots } = this.props;

    const paginationDots = [...Array(dots || 0)];

    return (
      <div className="demo-pagination" style={rootStyles}>
        {paginationDots.map((_val, i) => (
          <PaginationDot
            key={i}
            index={i}
            active={i === index}
            onClick={this.handleClick}
          />
        ))}
      </div>
    );
  }
}

PaginationMobile.propTypes = {
  dots: PropTypes.number.isRequired,
  index: PropTypes.number.isRequired,
  onChangeIndex: PropTypes.func.isRequired,
};

export default PaginationMobile;
